export class Validators {
   private static readonly urlFormatExp = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
   private static readonly salaryFormat = /^\d*\.?\d+$/;

   private static nameFormat = /^[A-Za-zА-Яа-яІіЇїЄєҐґЫы'’-]+$/;
   private static disallowedNameCharacters = /[^A-Za-zА-Яа-яІіЇїЄєҐґЫы'’-]/g;
   private static emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
   private static contactNumberFormat = /^\+\d{1,3}\d{6,14}$/;

   public static required(val: string | unknown[] | null | undefined | number): string {
      if (typeof val === 'string') {
         if (val === '') {
            return "Поле обов'язкове";
         } else {
            return '';
         }
      }

      if (Array.isArray(val)) {
         if (val.length === 0) {
            return "Поле обов'язкове";
         }
         return '';
      }

      if (typeof val === 'number') {
         return '';
      }

      if (val === null || val === undefined) {
         return "Поле обов'язкове";
      } else {
         return '';
      }
   }

   public static nameValidator(val: string): string {
      if (val && !Validators.nameFormat.test(val)) {
         return 'Має містити тільки букви';
      }
      return '';
   }

   public static sanitizeName(val: string): string {
      return val.replace(Validators.disallowedNameCharacters, '');
   }

   public static email(val: string): string {
      if (val && !Validators.emailFormat.test(val)) {
         return 'Неправильний формат електронної пошти';
      }
      return '';
   }

   public static contactNumber(val: string): string {
      if (val && !Validators.contactNumberFormat.test(val)) {
         return 'Номер повинен бути у міжнародному форматі: +380XXXXXXXXX';
      }
      return '';
   }

   public static urlFormat(val: string): string {
      if (val && !Validators.urlFormatExp.test(val)) {
         return 'Будь ласка, введіть дійсний URL вебсайту компанії';
      }
      return '';
   }

   public static salaryNumeric(val: string): string {
      if (val && !Validators.salaryFormat.test(val)) {
         return ' Має бути число';
      }
      return '';
   }
}
